import { t } from "ttag";

import { AreaTab, AreaTabGroup } from "metabase/nav/components/AreaLayout";
import { useLocation } from "metabase/router";
import * as Urls from "metabase/urls";

type UsageAnalyticsNavProps = {
  showLabel: boolean;
};

/** The Usage analytics group of the Monitor navigation. */
export function UsageAnalyticsNav({ showLabel }: UsageAnalyticsNavProps) {
  const { pathname } = useLocation();
  const isAt = (...paths: string[]) =>
    paths.some((path) => pathname.startsWith(path));

  return (
    <AreaTabGroup label={t`Usage analytics`} showLabel={showLabel} mb="lg">
      <AreaTab
        label={t`Activity`}
        icon="history"
        to={Urls.monitorUsageActivity()}
        isSelected={isAt(
          Urls.monitorUsageActivity(),
          `${Urls.monitorUsageAnalytics()}/item`,
        )}
        showLabel={showLabel}
      />
      <AreaTab
        label={t`Query log`}
        icon="database"
        to={Urls.monitorUsageQueries()}
        isSelected={isAt(Urls.monitorUsageQueries())}
        showLabel={showLabel}
      />
      <AreaTab
        label={t`People`}
        icon="person"
        to={Urls.monitorUsagePeople()}
        isSelected={isAt(Urls.monitorUsagePeople())}
        showLabel={showLabel}
      />
      <AreaTab
        label={t`Retention`}
        icon="clock"
        to={Urls.monitorUsageRetention()}
        isSelected={isAt(Urls.monitorUsageRetention())}
        showLabel={showLabel}
      />
    </AreaTabGroup>
  );
}
